// Supply Chain Tiers Section Javascript
// document.addEventListener('DOMContentLoaded', () => {
//   // The Splide carousel is initialized automatically by the <carousel-component> custom element
//   // defined in carousel.js.
//   // Any specific custom interactive behavior for Supply Chain Tiers can be added here.
//   // Currently, the hover effects are entirely handled via CSS.
// });

// Supply Chain Tiers Section Javascript

// Detect iOS / macOS and apply platform classes to <html> for CSS targeting.
(function () {
  var ua = navigator.userAgent || '';

  // iOS detection (iPhone, iPad, iPod) — must check BEFORE Mac, because
  // iOS 13+ iPads report 'MacIntel' in navigator.platform.
  var isIOS = /iPhone|iPad|iPod/i.test(ua) ||
              (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);

  if (isIOS) {
    document.documentElement.classList.add('is-ios');
  } else {
    // macOS detection (only when not iOS)
    var isMac = false;
    if (navigator.userAgentData && navigator.userAgentData.platform) {
      isMac = navigator.userAgentData.platform.toLowerCase().indexOf('mac') !== -1;
    } else {
      isMac = /Mac/.test(navigator.platform);
    }
    if (isMac) {
      document.documentElement.classList.add('is-mac');
    }
  }
})();

document.addEventListener('DOMContentLoaded', () => {
  // The Splide carousel is initialized automatically by the <carousel-component> custom element
  // defined in carousel.js.
  // Any specific custom interactive behavior for Supply Chain Tiers can be added here.
  // Currently, the hover effects are entirely handled via CSS.
});
